import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import Footer from "../components/footer/Footer";
import NavBar from "../components/navBar/NavBar";
import { useDispatch, useSelector } from "react-redux";
import TabBar from "../components/navBar/tabBar/TabBar";
import updateToken from "../store/updateToken/UpdateToken";
import { LanguageContext } from "../context/LanguageContext";
import { constantData } from "../utils/helpers/constantData";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getCountry } from "../utils/helpers/getCountry/getCountry";
import fetchLocalization from "../store/localization/FetchLocalization";
import style from "../components/footer/components/Components.module.css";
import { ReadBooksContext } from "../context/readBooksContext/ReadBooksContext";
import AgentButton from "../components/aiAgent/AgentButton";
import { CategoriesContext } from "../context/CategoriesContext";
import productCategories from "../store/category/ProductCategories";
import { SubscriptionPlansContext } from "../context/SubscriptionPlansContext";
import getSubscriptionListData from "../store/subscriptions/subscriptionsList/SubscriptionsList";
import getInvites from "../store/family/getInvites/GetInvites";
import FamilyInviteModal from "../components/modal/familyInviteModal/FamilyInviteModal";
import { UserContextProvider } from "../context/UserContext";
import { detectLanguage } from "../utils/languages";

const RootLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [country, setCountry] = useState();
  const token = Cookies.get("auth_token");
  const existenceToken = Cookies.get("token");
  const navBar = document.getElementById("navBar");
  const footer = document.getElementById("footer");
  const tabBar = document.getElementById("tabBar");
  const refreshToken = Cookies.get("refresh_token");
  const getInvitesData = useSelector((state) => state.getInvites);
  const categoriesData = useSelector((state) => state.categories.categories);
  const subscriptionListData = useSelector((state) => state.subscriptionList.subscriptionList);
  const [categories, setCategories] = useState(categoriesData ?? []);
  const [subscriptionPlans, setSubscriptionPlans] = useState(subscriptionListData ?? []);
  const preferedLanguage = Cookies.get("preferedLanguage");
  const keys = {
    "read-book": "add",
    "user-deletion-request": "add",
    "intro": "add",
    remove: "remove",
  };
  const [isFamilyModalDismissed, setIsFamilyModalDismissed] = useState(
    () => sessionStorage.getItem("familyInviteModalDismissed") === "true"
  );
 
  const handleFamilyModalClose = () => {
    sessionStorage.setItem("familyInviteModalDismissed", "true");
    setIsFamilyModalDismissed(true);
  };

  
  const localization = useSelector((state) => state.localization.localization);
  const SUPPORTED_LANGS = process.env.REACT_APP_LANGUAGES.split(",").map(s => s.trim());
  const prefLang = SUPPORTED_LANGS.includes(preferedLanguage) ? preferedLanguage : detectLanguage();
  const ROUTE_KEYS = ["read-book", "user-deletion-request", "intro"];
  const key = location?.pathname.split("/").find(seg => ROUTE_KEYS.includes(seg)) ?? "remove";
  const isIntroPage = location.pathname === "/intro";
  const isReadBookPage = location.pathname.includes("read-book");

  const [language, setLanguage] = useState(prefLang);
  const readBooksData = JSON.parse(localStorage.getItem("readingPageLocation"));
  const [readBooks, setReadBooks] = useState(readBooksData ?? {});

  useEffect(() => {
    Cookies.set('preferedLanguage', prefLang);
  }, [prefLang])

  useEffect(() => {
    dispatch(fetchLocalization());
    dispatch(productCategories());
    dispatch(getSubscriptionListData())
    if (token) {
      dispatch(getInvites(token))
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (localization && Object.keys(localization).length > 0) {
      setData(localization);
    }
    if (categoriesData && categoriesData?.length > 0) {
      setCategories(categoriesData);
    }
    if (subscriptionListData && subscriptionListData?.length > 0) {
      setSubscriptionPlans(subscriptionListData);
    }
  }, [localization, categoriesData, subscriptionListData]);

  useEffect(() => {
    setReadBooks(JSON.parse(localStorage.getItem("readingPageLocation")));
  }, []);

  constantData.paths.forEach((item) => {
    if (!location.pathname.includes(item.path)) {
      item.savedItems.forEach((savedItem) => {
        window.sessionStorage.removeItem(savedItem);
        window.localStorage.removeItem(savedItem);
      });
    }
  });

  [navBar, footer, tabBar].forEach((item) => {
    item?.classList[keys[key]](style.display_none);
  });

  useEffect(() => {
    if (location.pathname === "/user-deletion-request" || isIntroPage) {
      document.getElementById("root").style.padding = "0px";
    } else {
      document.getElementById("root").style.padding = "0 0 300px 0";
    }

    ["single-playlist", "read-book", "intro"].forEach((item) => {
      if (!location.pathname.includes(item)) {
        document.body.style.overflowY = "auto";
      }
    });

    if (!location.pathname.includes("read-book")) {
      document.body.style.background = "#ffff";
    }
  }, [location.pathname, isIntroPage])

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (
        window.innerWidth > 850 &&
        window.location.pathname.includes("/settings")
      ) {
        navigate("/");
      }
    });
  }, [navigate]);

  useEffect(() => {
    const date = new Date(localStorage.getItem("sessionClose"));
    const refreshUntill = (date - new Date()) / (24 * 60 * 1000);

    const generateAuthToken = async (tokenString) => {
      if (!token && refreshToken) {
        Cookies.remove("auth_token");
        const response = await dispatch(updateToken(tokenString));
        if (response.payload?.updatedToken.status === 200) {
          const expiresIn =
            (new Date(response.payload?.updatedToken.data.expireAt) -
              new Date()) /
            (1000 * 60 * 60 * 24);
          Cookies.set("auth_token", response.payload?.updatedToken.data.token, {
            expires: expiresIn,
          });
          window.location.reload();
        } else {
          Cookies.remove("auth_token");
          Cookies.remove("refresh_token");
        }
      } else if (!token && !refreshToken) {
        const keysToKeep = ['hasSeenOnboarding'];
        localStorage.clear()
        Object.keys(sessionStorage).forEach((key) => {
          if (!keysToKeep.includes(key)) {
            sessionStorage.removeItem(key);
          }
        });
      }
    };

    if (refreshUntill <= 12) {
      generateAuthToken(refreshToken);
    }
  }, [dispatch, refreshToken, token, location, existenceToken]);

  useEffect(() => {
    getCountry.userCountry(setCountry);
  }, []);

  useEffect(() => {
    window.localStorage.setItem('country', country)
  }, [location, country])

  useEffect(() => {
    const hasSeenIntro = sessionStorage.getItem('hasSeenOnboarding');
    
    if (!hasSeenIntro && !token) {
      navigate('/intro', { replace: true });
    }
  }, [navigate, token])
  
  const shouldShowFamilyModal = !isFamilyModalDismissed && getInvitesData.data !== null && getInvitesData.data?.length > 0;

  return (
    <LanguageContext.Provider value={{ language, data, setLanguage }}>
      <UserContextProvider>
        <CategoriesContext.Provider value={{ categories, setCategories }}>
          <SubscriptionPlansContext.Provider value={{ subscriptionPlans, setSubscriptionPlans }}>
            <ReadBooksContext.Provider
              value={{ readBooks: readBooks, setReadBooks }}
            >
              <NavBar token={token} country={country} />
              <Outlet />
              {shouldShowFamilyModal && (
                <FamilyInviteModal onClose={handleFamilyModalClose} getInvitesData={getInvitesData?.data}/>
              )}
              {token && !isIntroPage && !isReadBookPage && <AgentButton />}
              <TabBar />
              <Footer />
            </ReadBooksContext.Provider>
          </SubscriptionPlansContext.Provider>
        </CategoriesContext.Provider>
      </UserContextProvider>
    </LanguageContext.Provider>
  );
};

export default RootLayout;
